import { render, staticRenderFns } from "./AuthoriseView.vue?vue&type=template&id=c1291c70&scoped=true"
import script from "./AuthoriseView.vue?vue&type=script&lang=js"
export * from "./AuthoriseView.vue?vue&type=script&lang=js"
import style0 from "./AuthoriseView.vue?vue&type=style&index=0&id=c1291c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1291c70",
  null
  
)

export default component.exports